module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAALJJREFUOE+tlFERwjAQRN8qojgABzgACUhBAhKQgAQkVAIOljkmYdrSTKdp+tePvNl7m4to9KkRh7Yg21fgDBwlvW13wBM4SHpFats9cMr/00l+iWzfgd0AdgFuGZbgjxJsNNoW2J+jWtis7BpYsbUMk7RPsrOzTlI/dbYEikPRYLS2HpTSBCDqj+uw2GBJ9ipIJJ6rfzVkBKoZZ3i7v4nSioSH7KR+Rba+Am23f2uaOP8BnTSyEzHxjj0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/link.png
// module id = h1VE
// module chunks = 0